import React, { useMemo } from 'react';
import { ThemeProvider as JssThemeProvider } from 'react-jss';
import Color from 'color';

import {
  muiTheme,
  theme as bUXTheme,
  ColorPalette,
  buildColorProperties,
} from '@app/theme';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

const colors: ColorPalette = {
  ...bUXTheme.basicColors,

  redAccessible: Color('#DC3A16'),
  red: Color('#FF5533'),
  redMuted: Color('#FFE4D8'),

  accentAccessible: Color('#DC3A16'),
  accent: Color('#FF5533'),
  accentMuted: Color('#FFE4D8'),
};

const theme = {
  ...bUXTheme,
  ...buildColorProperties(colors),
  borderRadius: {
    std: 4,
    large: 16,
  },
  boxShadow: {
    base: '0px 4px 15px rgba(25, 41, 72, 0.15)',
    mobile: '0px -4px 25px rgba(0, 0, 0, 0.15);',
  },
};

interface Props {
  children: React.ReactNode;
}

export const ThemeProvider = ({ children }: Props) => {
  return (
    <JssThemeProvider theme={theme}>
      <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
    </JssThemeProvider>
  );
};
